import { Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';

type Props = {
  itemList: { id: string; value: string }[];
  removeItemFunc: (id: string) => void;
  disableAllRemove?: boolean;
};

/*
Used in:
  - Admin Panel -> CaseCluster -> Create
  - Admin Panel -> Meeting -> Create
*/
export default function ItemList({ itemList, removeItemFunc, disableAllRemove }: Props) {
  return (
    <>
      {itemList.map((item) => (
        <Tag key={item.id} size="sm" bgColor="primary" color="white">
          <TagLabel>{item.value}</TagLabel>
          <TagCloseButton isDisabled={disableAllRemove} onClick={() => removeItemFunc(item.id)} />
        </Tag>
      ))}
    </>
  );
}
